export enum PrintersOrderBy {
	Name = 'Name',
	DisplayName = 'DisplayName',
	Firmware = 'Firmware',
	Status = 'Status',
}
